import React from 'react';
import './gallery.css';

const certifications = [
  { src: require('../../assets/Sertifikat/fmfinisher.jpg'), title: 'Full Marathon Finisher BTN Jakim 2026 😅', logo: require('../../assets/logos/btn.png') },
  { src: require('../../assets/Sertifikat/1763305552693.jpg'), title: '2nd place winner of the 2025 Indonesian Ministry and Institution CTF Cyber ​​Competition', logo: require('../../assets/logos/bin.png') },
  { src: require('../../assets/Sertifikat/sertifikat (12).jpg'), title: 'Satsiber TNI HoF 2025', logo: require('../../assets/logos/tni.png') },
  { src: require('../../assets/Sertifikat/sertifikat (13).jpg'), title: 'Cryptography Module Analyst (CMA)', logo: require('../../assets/logos/bnsp.png') },
  { src: require('../../assets/Sertifikat/sertifikat (14).jpg'), title: 'APISEC Certified Practicioner', logo: require('../../assets/logos/apisec.png') },
  { src: require('../../assets/Sertifikat/sertifikat (9).jpg'), title: 'Certified APPsec Practicioner (CAP)', logo: require('../../assets/logos/secops.png') },
  { src: require('../../assets/Sertifikat/sertifikat (3).jpg'), title: 'Google IT Support', logo: require('../../assets/logos/google.png') },
  { src: require('../../assets/Sertifikat/sertifikat (2).jpg'), title: 'Google CyberSecurity', logo: require('../../assets/logos/google.png') },
  { src: require('../../assets/Sertifikat/sertifikat (6).jpg'), title: 'Cybersecurity Awareness Professional Certification (CAPC)', logo: require('../../assets/logos/certiprof.png') },
  { src: require('../../assets/Sertifikat/sertifikat (1).png'), title: 'Microsoft SC-900', logo: require('../../assets/logos/microsoft.png') },
];

const Gallery = () => {
  return (
    <section className="gallery section" id="gallery">
      <h2 className="section__title">Milestone</h2>
      <span className="section__subtitle">little bit about my experience</span>

      <div className="gallery__container container">
        <ul className="gallery__list">
          {certifications.map(({ src, title, logo, initials }) => (
            <li key={title} className="gallery__item">
              <a
                href={src}
                target="_blank"
                rel="noopener noreferrer"
                className="gallery__link"
                aria-label={`View ${title} certificate in new tab`}
              >
                {logo ? (
                  <img src={logo} alt="" className="gallery__logo" loading="lazy" />
                ) : (
                  <span className="gallery__logo gallery__logo--initials">{initials}</span>
                )}
                <span className="gallery__label">{title}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Gallery;
